import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import dayjs from "dayjs";
const DateRangeDescription = ({ fromISOTimestamp, toISOTimestamp }) => {
    const from = dayjs(fromISOTimestamp);
    if (!toISOTimestamp) {
        if (from.format('HH:mm') == "00:00") {
            return from.format("DD/MM/YYYY");
        }
        return from.format("DD/MM/YYYY HH:mm");
    }
    const to = dayjs(toISOTimestamp);
    if (from.isSame(to, 'day')) {
        const fromTime = from.format('HH:mm');
        if (fromTime === to.format('HH:mm')) {
            if (fromTime === "00:00") {
                return (_jsx("span", { children: from.format("DD/MM/YYYY") }));
            }
            else {
                return (_jsxs("span", { children: [from.format("DD/MM/YYYY"), _jsx("br", {}), fromTime] }));
            }
        }
        return (_jsxs("span", { children: [from.format("DD/MM/YYYY"), _jsx("br", {}), fromTime, " - ", to.format("HH:mm")] }));
    }
    return (_jsxs("span", { children: [from.format("DD/MM/YYYY HH:mm"), _jsx("br", {}), to.format("DD/MM/YYYY HH:mm")] }));
};
export default DateRangeDescription;
